import { AUTOHIDE_TIMEOUTS, load } from '../util';

$(document).on('scan', '[data-mobile-search]', function(event, scanner, result) {
  scanner.pause(true);
  scanner.picker.beepSound.play();
  $(this).find('[data-mobile-search-input]').val(result.barcodes[0].data);
  $(this).submit();
});

$(document).on('scan', '[data-search]', function(event, scanner, result) {
  scanner.pause(true);
  scanner.picker.beepSound.play();
  $(this).find('[data-instant-search]').val(result.barcodes[0].data);
  $(this).submit();
});

function showScannerError(error) {
  const m = $('<div class="flashmessage error" data-closable>' +
    '    <div class="container"></div>' +
    '    <button class="close-button" type="button" data-close>' +
    '        <i class="icon icon-close-fill" aria-hidden="true"></i>' +
    '    </button>' +
    '</div>');
  m.find('.container').text(error.message);
  $('[data-flashmessages]').append(m);
  $('[data-flashmessages] [data-close]').foundation();
  setTimeout(() => m.remove(), AUTOHIDE_TIMEOUTS['autohide--fast']);
}

$(document).on('scan', '[data-fastentry-form]', function(event, scanner, result) {
  const formData = new FormData();
  formData.append('render', '1');
  formData.append('calculate', '1');
  formData.append('csrfmiddlewaretoken', $(this).find('[name="csrfmiddlewaretoken"]').val());

  scanner.pause(true);

  $.ajax({
    url: $(this).attr('data-action-info'),
    data: {
      item_id: result.barcodes[0].data,
    },
    success: (data) => {
      if (data.item_id && data.status === 'success') {
        scanner.picker.beepSound.play();
        formData.append('item_id', data.item_id);
        const app = $(this).attr('data-fastentry-form');
        load(this, $.stores[app].post($(this).attr('action'), formData)).then(() => {
          scanner.start().catch(showScannerError);
          const $elem = $(`[data-cart-item="${data.item_id}"]`);
          if ($elem.length > 0) {
            $('html, body').animate({
              scrollTop: $elem.offset().top - 48, // Consider header height
            }, 100);
          }
        });
      } else {
        $('.scandit-laser > img').css('background-color', 'red');
        window.setTimeout(() => {
          $('.scandit-laser > img').css('background-color', '');
        }, 500);
        scanner.start().catch(showScannerError);
      }
    },
    error: () => {
      $('.scandit-laser > img').css('background-color', 'red');
      window.setTimeout(() => {
        $('.scandit-laser > img').css('background-color', '');
      }, 500);
      scanner.start().catch(showScannerError);
    },
  });
});

$(() => {
  const $scannerWrapper = $('[data-scanner-wrapper]');
  let scanner = null;
  const getScanner = () => scanner;

  $(document).on('click', '[data-scanner-toggle]', async function (event) {
    event.preventDefault();

    const $this = $(this);
    const licenseKey = $this.attr('data-scanner-toggle');

    // Check if fastentry
    const target = $this.attr('data-scanner-target');
    const $holdingForm = target ? $(target) : $this.closest('form');
    if ($this.attr('data-scanner-size')) {
      $scannerWrapper.addClass(`scanner-container--${$this.attr('data-scanner-size')}`);
    }
    const onScanHandler = (scanResult) => {
      $holdingForm.trigger('scan', [getScanner(), scanResult]);
    };

    let scannerWasHidden = false;
    if ($scannerWrapper.hasClass('hide')) {
      $scannerWrapper.addClass('loading');
      $scannerWrapper.removeClass('hide');
      scannerWasHidden = true;
    }

    // load scanner library and get scanner instance if needed
    if (scanner == null) {
      await import(/* webpackChunkName: "scanner" */ './scanner').then(async ({ Scanner }) => {
        scanner = new Scanner(licenseKey);
        try {
          await scanner.init();
        } catch (error) {
          showScannerError(error);
        }
      });
    }

    if (scanner.picker) {
      scanner.setOnScanCallback(onScanHandler);
      scanner.setOnScanErrorCallback(showScannerError);

      if (scannerWasHidden) {
        scanner.start().then(() => {
          $scannerWrapper.removeClass('loading');
        }).catch((error) => {
          scanner.stop();
          $scannerWrapper.addClass('hide');
          showScannerError(error);
        });
      } else {
        scanner.stop();
        $scannerWrapper.addClass('hide');
      }
    } else {
      $scannerWrapper.addClass('hide');
    }
  });
});
